export default __webpack_public_path__ + "static/media/lumini_page.4c5ee8db.png";